export default class Label {
  constructor(api) {
    this.api = api;
  }

  getAll(rowsPerPage, page, sort, filters, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/networks/labels?paginate=false"/*  + rowsPerPage + page + sort + filters */)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/networks/labels/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createInBulk(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/networks/labels", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateInBulk(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/networks/labels/", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteInBulk(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/networks/labels/", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/networks/labels/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/label.js